import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

// const generateUUID = () => {
//   const alphanum =
//     "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
//   return Array.from(
//     { length: 6 },
//     () => alphanum[Math.floor(Math.random() * alphanum.length)]
//   ).join("");
// };

export function* handleFetchOrders({ payload }) {
  try {
    const res = yield call(API.fetchOrderDetails, payload);
    const { data } = res;
    yield put(actions.fetchOrderDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchOrderDetailsFailure(err?.response?.data));
  }
}

export function* handleUpdateReport({ payload }) {
  try {
    // const uuid = generateUUID();

    let labReportFileName = "";
    let labReportMetadataFileName = "";

    console.log("hello world: ", payload);

    //upload of lab report
    if (typeof payload.labReport === "object") {
      const labReportRes = yield call(API.getFileUrl, {
        blobName: `${payload.labReport.name.split(".")[0]}_report_${
          payload.orderId
        }.${payload.labReport.name.split(".")[1]}`,
        source: {
          name: process.env.REACT_APP_ENVIRONMENT,
        },
      });

      const labReportSASToken = labReportRes.data?.data?.document;

      const labReportUploadRes = yield call(API.uploadFile, {
        data: payload.labReport,
        url: labReportSASToken,
      });
      if (labReportUploadRes.status > 400) {
        throw new Error("Error uploading file");
      }
      labReportFileName = `${payload.labReport.name.split(".")[0]}_report_${
        payload.orderId
      }.${payload.labReport.name.split(".")[1]}`;
      console.log("if typeof payload.labReport === object");
    } else {
      labReportFileName = payload.labReport;
    }

    //upload of lab report metadata
    if (typeof payload.labReportMetadata === "object") {
      const labReportMetadataRes = yield call(API.getFileUrl, {
        blobName: `${payload.labReportMetadata.name.split(".")[0]}_metadata_${
          payload.orderId
        }.${payload.labReportMetadata.name.split(".")[1]}`,
        source: {
          name: process.env.REACT_APP_ENVIRONMENT,
        },
      });

      const labReportMetadataSASToken =
        labReportMetadataRes.data?.data?.document;

      const labReportMetadataUploadRes = yield call(API.uploadFile, {
        data: payload.labReportMetadata,
        url: labReportMetadataSASToken,
      });
      if (labReportMetadataUploadRes.status > 400) {
        throw new Error("Error uploading file");
      }
      labReportMetadataFileName = `${
        payload.labReportMetadata.name.split(".")[0]
      }_metadata_${payload.orderId}.${
        payload.labReportMetadata.name.split(".")[1]
      }`;
      console.log("if typeof payload.labReportMetadata === object");
    } else {
      labReportMetadataFileName = payload.labReportMetadata;
    }
    yield call(API.saveLabResponseDetails, {
      id: payload.id,
      data: {
        ...payload,
        labReport: labReportFileName,
        labReportMetadata: labReportMetadataFileName,
      },
    });

    // start PDF parsing, 
    // if order status is under dispute then check all corrections request is resolved if yes then call PDF parsing
    const orderDetails = payload.orderDetails;
    if (orderDetails?.status?.value === "underDispute") {
      const requestCorrections =
        orderDetails?.underDispute?.at(-1)?.requestCorrections;
      const allCorrectionsResolved = requestCorrections.every(
        (correction) =>
          correction.type === "report" || correction.isResolved === true
      );
      if (allCorrectionsResolved) {
        // All corrections are resolved then call PDF parsing
        yield call(API.startPdfParsing, {
          order_id: payload.orderId,
        });
      }
    } else {
      // Handle case when not under dispute
      yield call(API.startPdfParsing, {
        order_id: payload.orderId,
      });
    }

    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.updateReportFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* labReportReUploadSaga() {
  yield takeLatest(actions.fetchOrderDetails.type, handleFetchOrders);
  yield takeEvery(actions.updateReport.type, handleUpdateReport);
}
